import { render } from "./ArticleCard.vue?vue&type=template&id=37d04326"
import script from "./ArticleCard.vue?vue&type=script&lang=js"
export * from "./ArticleCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__